import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import businessRules from '../../../../../../../../../constants/businessRules/businessRules';
import ElementErrorSign from '../../../../../../../../../componentLibrary/ElementErrorSign';

export default class PulseRangeFaces extends PureComponent {
    render() {
        // eslint-disable-next-line react/destructuring-assignment
        const { iconSize, iconImages, paddingTop, paddingRight, paddingLeft, paddingBottom } = this.props.contentValues;
        const { hasError } = this.props;
        return (
            // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
            <table style={{ width: '100%' }} cellSpacing="0" cellPadding="0" tabIndex="0">
                <tbody>
                    <tr>
                        {hasError && (
                            <ElementErrorSign
                                dataFor="survey-element-title-help"
                                tooltipMsg="Update your survey title in the right panel, so it appears in your email report."
                            />
                        )}
                        <td
                            align="center"
                            verticalalign="middle"
                            style={{
                                fontSize: 0,
                                paddingTop,
                                paddingRight,
                                paddingBottom,
                                paddingLeft,
                                wordBreak: 'break-word',
                            }}
                        >
                            <table
                                align="center"
                                border="0"
                                cellPadding="0"
                                cellSpacing="0"
                                role="presentation"
                                style={{ borderCollapse: 'separate', lineHeight: '100%' }}
                            >
                                <tbody>
                                    <tr>
                                        <td align="center" valign="middle" role="presentation">
                                            <table
                                                align="center"
                                                border="0"
                                                cellSpacing="0"
                                                cellPadding="0"
                                                role="presentation"
                                                style={{ float: 'none', display: 'inline-table' }}
                                            >
                                                <tbody>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                padding: businessRules.SURVEY_ICONS_ELEMENTS_PADDING,
                                                            }}
                                                        >
                                                            <table
                                                                align="center"
                                                                border="0"
                                                                cellSpacing="0"
                                                                cellPadding="0"
                                                                role="presentation"
                                                                style={{ width: iconSize }}
                                                            >
                                                                <tbody>
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                fontSize: 0,
                                                                                height: iconSize,
                                                                                verticalAlign: 'middle',
                                                                                width: iconSize,
                                                                            }}
                                                                        >
                                                                            <img
                                                                                src={
                                                                                    iconImages.PULSE_RANGE_FACES
                                                                                        .VERY_UNHAPPY
                                                                                }
                                                                                width={iconSize}
                                                                                height={iconSize}
                                                                                alt="Very Unhappy"
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table
                                                align="center"
                                                border="0"
                                                cellSpacing="0"
                                                cellPadding="0"
                                                role="presentation"
                                                style={{ float: 'none', display: 'inline-table' }}
                                            >
                                                <tbody>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                padding: businessRules.SURVEY_ICONS_ELEMENTS_PADDING,
                                                            }}
                                                        >
                                                            <table
                                                                align="center"
                                                                border="0"
                                                                cellSpacing="0"
                                                                cellPadding="0"
                                                                role="presentation"
                                                                style={{ width: iconSize }}
                                                            >
                                                                <tbody>
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                fontSize: 0,
                                                                                height: iconSize,
                                                                                verticalAlign: 'middle',
                                                                                width: iconSize,
                                                                            }}
                                                                        >
                                                                            <img
                                                                                src={
                                                                                    iconImages.PULSE_RANGE_FACES.UNHAPPY
                                                                                }
                                                                                width={iconSize}
                                                                                height={iconSize}
                                                                                alt="Unhappy"
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table
                                                align="center"
                                                border="0"
                                                cellSpacing="0"
                                                cellPadding="0"
                                                role="presentation"
                                                style={{ float: 'none', display: 'inline-table' }}
                                            >
                                                <tbody>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                padding: businessRules.SURVEY_ICONS_ELEMENTS_PADDING,
                                                            }}
                                                        >
                                                            <table
                                                                align="center"
                                                                border="0"
                                                                cellSpacing="0"
                                                                cellPadding="0"
                                                                role="presentation"
                                                                style={{ width: iconSize }}
                                                            >
                                                                <tbody>
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                fontSize: 0,
                                                                                height: iconSize,
                                                                                verticalAlign: 'middle',
                                                                                width: iconSize,
                                                                            }}
                                                                        >
                                                                            <img
                                                                                src={
                                                                                    iconImages.PULSE_RANGE_FACES
                                                                                        .INDIFFERENT
                                                                                }
                                                                                width={iconSize}
                                                                                height={iconSize}
                                                                                alt="Indifferent"
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table
                                                align="center"
                                                border="0"
                                                cellSpacing="0"
                                                cellPadding="0"
                                                role="presentation"
                                                style={{ float: 'none', display: 'inline-table' }}
                                            >
                                                <tbody>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                padding: businessRules.SURVEY_ICONS_ELEMENTS_PADDING,
                                                            }}
                                                        >
                                                            <table
                                                                align="center"
                                                                border="0"
                                                                cellSpacing="0"
                                                                cellPadding="0"
                                                                role="presentation"
                                                                style={{ width: iconSize }}
                                                            >
                                                                <tbody>
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                fontSize: 0,
                                                                                height: iconSize,
                                                                                verticalAlign: 'middle',
                                                                                width: iconSize,
                                                                            }}
                                                                        >
                                                                            <img
                                                                                src={iconImages.PULSE_RANGE_FACES.HAPPY}
                                                                                width={iconSize}
                                                                                height={iconSize}
                                                                                alt="Happy"
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table
                                                align="center"
                                                border="0"
                                                cellSpacing="0"
                                                cellPadding="0"
                                                role="presentation"
                                                style={{ float: 'none', display: 'inline-table' }}
                                            >
                                                <tbody>
                                                    <tr>
                                                        <td
                                                            style={{
                                                                padding: businessRules.SURVEY_ICONS_ELEMENTS_PADDING,
                                                            }}
                                                        >
                                                            <table
                                                                align="center"
                                                                border="0"
                                                                cellSpacing="0"
                                                                cellPadding="0"
                                                                role="presentation"
                                                                style={{ width: iconSize }}
                                                            >
                                                                <tbody>
                                                                    <tr>
                                                                        <td
                                                                            style={{
                                                                                fontSize: 0,
                                                                                height: iconSize,
                                                                                verticalAlign: 'middle',
                                                                                width: iconSize,
                                                                            }}
                                                                        >
                                                                            <img
                                                                                src={
                                                                                    iconImages.PULSE_RANGE_FACES
                                                                                        .VERY_HAPPY
                                                                                }
                                                                                width={iconSize}
                                                                                height={iconSize}
                                                                                alt="Very Happy"
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    }
}

PulseRangeFaces.propTypes = {
    hasError: PropTypes.bool.isRequired,
    contentValues: PropTypes.shape({
        iconSize: PropTypes.number.isRequired,
        iconImages: PropTypes.object.isRequired,
        paddingTop: PropTypes.number.isRequired,
        paddingRight: PropTypes.number.isRequired,
        paddingLeft: PropTypes.number.isRequired,
        paddingBottom: PropTypes.number.isRequired,
    }).isRequired,
};
